import { useSelector } from "react-redux";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

import React from "react";
import { currentlyEditingSleeperSelector } from "../../../redux/slices/customNavigation";
import { isSingleSleeperSelector } from "../../../redux/slices/mattressConfiguration";
import EvrSleeperFirmnessModal from "./EvrSleeperFirmnessModal";
import EvrSleeperPainPointsModal from "./EvrSleeperPainPointsModal";
import MattressBackground from "../../../components/content/MattressBackground";
import useMediaQuery from "@mui/material/useMediaQuery";
import GlobalEvrScore from "./GlobalEvrScore";

const BedBuilderContentStep4 = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSingleSleeper = useSelector(isSingleSleeperSelector);

  const currentlyEditingSleeper = useSelector(currentlyEditingSleeperSelector);

  const editingSleeper1 = currentlyEditingSleeper === 1;
  //Media Queries
  const isSmallScreen = useMediaQuery("(min-width:600px)");
  const isMediumScreen = useMediaQuery("(min-width:900px) ");
  const isLargeScreen = useMediaQuery("(min-width:1200px)");
  const isExtraLargeScreen = useMediaQuery("(min-width:1536px)");

  return (
    <>
      <MattressBackground showCondition={true}>
        <GlobalEvrScore></GlobalEvrScore>
        <EvrSleeperFirmnessModal />
      </MattressBackground>
    </>
  );
};

export default BedBuilderContentStep4;
